import { Col } from "components/primitives";
import { Button } from "react-bootstrap";
import styled from "styled-components";
import { WidgetSettingFC } from "types/Setting";

import { InfoState } from "./types";

export const FreeHandWritingSettings: WidgetSettingFC<any, InfoState> = (props) => {
  const {
    data,
    setData,
    info: { label },
    state,
  } = props;

  const selectedLine = data?.selectedLine;

  return (
    <OuterContainer noMargin={false}>
      <p className="label">{label}</p>
      <Space />
      <InnerContainer>
        <LineOptionsContainer>
          {lineOptions.map(({ label, value }) => (
            <FreeDrawOptionButton
              key={value}
              className={`${
                selectedLine === value ? "active" : ""
              }`} /* Add `active` class when selected */
              onClick={() => setData({ ...data, selectedLine: value })}
            >
              {label}
            </FreeDrawOptionButton>
          ))}
        </LineOptionsContainer>
      </InnerContainer>
    </OuterContainer>
  );
};

const lineOptions = [
  { label: "Two Solid Two Dotted Lines", value: "TwoSolidTwoDottedSvg" },
  { label: "Black and Red Solid Lines", value: "BlackAndRedSolidSvg" },
  { label: "Blank Lines", value: "BlankLinesSvg" },
  { label: "Double Lines", value: "DoubleLinesSvg" },
  { label: "Ground, Grass, Sky", value: "GroundGrassSkySvg" },
  { label: "One Dotted Solid Line", value: "OneDottedSolidLineSvg" },
  { label: "One Solid Two Dotted Lines", value: "OneSolidTwoDottedLinesSvg" },
  {
    label: "Solid with Red and Dotted Lines",
    value: "SolidWithRedAndDottedLinesSvg",
  },
];

const OuterContainer = styled(Col)<{ noMargin: boolean }>`
  margin-bottom: ${(props) => (props.noMargin ? "0px" : "35px")};

  .label {
    margin-bottom: 8px;
    font-weight: 600;
    font-size: 12pt;
  }
`;

const Row = styled.div<{ center?: boolean }>`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: ${(props) => (props.center ? `space-evenly` : "flex-start")};
  gap: 8px;
`;

const Space = styled.div`
  height: 8px;
`;

const InnerContainer = styled(Row)`
  align-items: center;
  gap: 10px;

  span {
    color: var(--gray);
  }
`;

const LineOptionsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
`;
export const FreeDrawOptionButton = styled(Button)`
  background-color: #fff;
  border-radius: 8px;
  border: 2px solid rgb(255, 143, 113);
  color: #000; /* Default text color */

  &:disabled {
    background-color: #dcdcdc;
    border-color: rgb(255, 143, 113);
    color: #a0a0a0; /* Muted text color for disabled state */
    cursor: not-allowed;
    box-shadow: none; /* No shadow for disabled state */
  }

  &:hover,
  &:not(:disabled):not(.disabled):active,
  &:focus {
    background-color: #ffe4e4 !important;
    border-color: rgb(255, 143, 113) !important;
    box-shadow: 0 0 0 0.2rem rgba(222, 128, 129, 0.5) !important;
    color: #000 !important;
  }

  &.active {
    background-color: #ffe4e4 !important;
    border-color: rgb(255, 143, 113) !important;
    box-shadow: 0 0 0 0.2rem rgba(222, 128, 129, 0.5) !important;
    color: #000 !important;
    transition: all 0.3s ease; /* Smooth transition *//
  }

  svg {
    width: 1.5rem;

    path {
      fill: rgb(255, 143, 113); /* Match the border color */
    }
  }
`;

export default FreeHandWritingSettings;
